import clsx from 'clsx'

import { Button, Dialog } from '@buffer-mono/popcorn'

import { TrackRender } from '~publish/hooks/tracking'

import { Limits } from '../../constants'

import styles from './HardLimitReachedDialog.module.css'

import type { JSX } from 'react'

export const HardLimitReachedDialog = ({
  enabled,
  type,
  tier,
  className,
  children,
  open,
  onOpenChange,
}: {
  enabled?: boolean
  type: 'feeds' | 'collections' | 'feedspercollection'
  tier: 'free' | 'paid'
  className?: string
  children?: JSX.Element
  open?: boolean
  onOpenChange?: (open: boolean) => void
}): JSX.Element | null => {
  if (!enabled) {
    return children ?? null
  }

  const messageContext = {
    feeds: {
      limit: Limits.feeds[tier].total,
      item: 'feeds',
      addMore: 'feeds',
    },
    collections: {
      limit: Limits.collections[tier],
      item: 'collections',
      addMore: 'collections',
    },
    feedspercollection: {
      limit: Limits.feeds[tier].perCollection,
      item: 'feeds per collection',
      addMore: 'feeds to this collection',
    },
  }[type]

  return (
    <Dialog
      key="hardLimitReachedDialog"
      open={open}
      onOpenChange={onOpenChange}
    >
      {/* asChild needs to be false to support multiple conditional dialogs around one trigger */}
      {children && (
        <Dialog.Trigger
          asChild={false}
          className={clsx(styles.trigger, className)}
        >
          {children}
        </Dialog.Trigger>
      )}
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Limit Reached!</Dialog.Title>
          <Dialog.Description>
            You have reached the limit of {messageContext.limit}{' '}
            {messageContext.item}. Adding more {messageContext.addMore} is
            currently not supported.
          </Dialog.Description>
          <TrackRender componentName="HardLimitReachedDialog" type={type} />
        </Dialog.Header>
        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="primary" size="large">
              Got It
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
